import React from "react";

import _ from "lodash";
import { AgGridReact } from "ag-grid-react";
import {
  ClientSideRowModelModule,
  ValidationModule,
  RowSelectionModule,
  TextFilterModule,
  NumberFilterModule,
  DateFilterModule,
  CustomFilterModule,
  PaginationModule,
} from "ag-grid-community";
import Button from "react-bootstrap/Button";
import Skeleton from "@mui/material/Skeleton";
import { Label18 } from "../components";
import { API_URL } from "../utils/Constants";
import { ApiService } from "../utils/ApiService";
import "../App.css";
import { getMerchantId } from "../utils/Helper";

const REPORT_STATUS = {
  COMPLETED: "COMPLETED",
  INPROGRESS: "IN_PROGRESS",
  FAILED: "FAILED",
};

const downloadLabelStyle = {
  display: "inline-block",
  position: "relative",
  top: "3px",
};

const adhocInstTileStyle = {
  margin: "10px 5px",
  display: "flex",
  "justify-content": "space-between",
};

const refreshBtnContaninerStyle = {
  "margin-right": "20px",
};

const refreshBtnOvertideStyle = {
  height: "30px !important",
  width: "30px !important",
  border: "0px",
};

const DownloadLabel = (params) => {
  return (
    <a onClick={params.onClick}>
      <div className="download_arrow" style={downloadLabelStyle} />
      <label className="downloadLabel">Download</label>
    </a>
  );
};

export class AdhocInstructionsView extends React.Component {
  reloadData = false;
  state = {
    page: { offset: 0, limit: 10000 },
    data: [],
    isLoading: true,
  };
  downloadHandler = (fileName) => {
    let authCode = localStorage.getItem("bearer");
    let merchantId = getMerchantId();
    const url =
      API_URL.DOWNLOAD_REPORT +
      "?fileName=" +
      fileName +
      "&merchantId=" +
      merchantId;
    fetch(url, {
      method: "POST",
      headers: {
        Authorization: authCode,
        Accept: "application/json",
        merchantId: merchantId,
      },
    })
      .then((response) => {
        const auth = response.headers.get("Authorization");
        if (auth) localStorage.setItem("bearer", auth);
        return response.blob();
      })
      .then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove(); //afterwards we remove the element again
      })
      .catch((err) => console.error(err));
  };

  renderAction = (params) => {
    return params?.data?.status === REPORT_STATUS.COMPLETED ? (
      <DownloadLabel
        onClick={() => this.downloadHandler(params.data.fileName)}
      />
    ) : null;
  }

  columnDefs = [
    { headerName: "File Name", field: "fileName", width: 450 },
    {
      headerName: "From Date",
      cellRenderer: (params) =>
        params?.data?.fromDate?.split("T")[0],
    },
    {
      headerName: "To Date",
      cellRenderer: (params) =>
        params?.data?.toDate?.split("T")[0],
    },
    { headerName: "Status", field: "status" },
    {
      headerName: "Action",
      width: 200,
      cellRenderer: this.renderAction,
    },
  ];

  readAdhocInstr = async () => {
    const params = this.constructQueryParams(this.props.reportConfig);
    const url =
      API_URL.REPORT_ADHOC_INSTRUCTION +
      "?limit=" +
      this.state.page.limit +
      "&offset=" +
      this.state.page.offset +
      params;

    const response = await ApiService.getRequest(url);
    if (response.status.code == "Y") {
      this.setState({ data: response.body, isLoading: false });
    }
  };

  constructQueryParams = (reportConfig) => {
    let queryparam = "";
    for (let [key, value] of Object.entries(reportConfig)) {
      if (value) {
        queryparam += "&" + key + "=" + value;
      }
    }
    return queryparam;
  };

  reloadAdhocInstructions = () => {
    this.setState({ isLoading: true });
    this.readAdhocInstr();
  };

  shouldComponentUpdate(nextProps, nextState) {
    const isStateChanged = !_.isEqual(this.state, nextState);
    this.reloadData = !this.props.reload && nextProps.reload; //only update when reload flag is changing from false -> true
    return isStateChanged || this.reloadData;
  }

  componentDidMount() {
    this.readAdhocInstr();
  }

  componentDidUpdate() {
    if (this.reloadData) {
      this.reloadAdhocInstructions();
      this.reloadData = false;
    }
  }

  render() {
    if (this.state.isLoading) {
      return (
        <Skeleton animation="wave" variant="text" width="100%" height={400} />
      );
    }
    return (
      <div
        style={{
          height: 400,
          overflowX: "auto",
        }}
        className="w-100"
      >
        <div style={adhocInstTileStyle} className="p-3">
          <Label18 bold>Download reports</Label18>
          <div style={refreshBtnContaninerStyle}>
            <Button
              varient="link"
              className="SyncData btn btn-primary"
              style={refreshBtnOvertideStyle}
              onClick={this.reloadAdhocInstructions}
            ></Button>
          </div>
        </div>

        <AgGridReact
          modules={[
            ClientSideRowModelModule,
            ValidationModule,
            RowSelectionModule,
            TextFilterModule,
            NumberFilterModule,
            DateFilterModule,
            CustomFilterModule,
            PaginationModule,
          ]}
          columnDefs={this.columnDefs}
          rowData={this.state.data}
          pagination={true}
          paginationPageSize={20}
        />
      </div>
    );
  }
}

export default AdhocInstructionsView;
